import { render } from "./DistrictExecutiveList.vue?vue&type=template&id=50266a7c&scoped=true"
import script from "./DistrictExecutiveList.vue?vue&type=script&lang=js"
export * from "./DistrictExecutiveList.vue?vue&type=script&lang=js"

import "./DistrictExecutiveList.vue?vue&type=style&index=0&id=50266a7c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50266a7c"]])

export default __exports__